import { useSelector } from 'react-redux';
import { MANAGE_VIEW_TYPE } from '../Model/Model';
import ManageMainHeader from './ManageMainHeader';
import GeofencesCards from "./GeofencesCards";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Geofences = (props) => {
    const { subView, handleSubViewChange, searchElement, setSearchElement } = props;
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    return (
        <>
            <ManageMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                DEV={DEV}
                permission={permission}
                viewType={MANAGE_VIEW_TYPE.GEOFENCES}
            />
            <GeofencesCards
                searchElement={searchElement}
                setSearchElement={setSearchElement}
            />
        </>
    );
};

export default Geofences;
